var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 41,
    viewBox: "0 0 57 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_3212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.1681 6.76018C54.8446 5.56437 54.2134 4.47419 53.3374 3.59819C52.4615 2.72219 51.3713 2.09095 50.1755 1.76732C45.7977 0.573364 28.1784 0.573364 28.1784 0.573364C28.1784 0.573364 10.5583 0.609504 6.18047 1.80346C4.98464 2.12711 3.89447 2.75839 3.01851 3.63442C2.14255 4.51046 1.51137 5.60069 1.18782 6.79654C-0.136365 14.5751 -0.650042 26.4278 1.22418 33.8951C1.54776 35.0909 2.17896 36.1811 3.05492 37.0571C3.93088 37.9331 5.02103 38.5644 6.21683 38.888C10.5946 40.0819 28.2143 40.0819 28.2143 40.0819C28.2143 40.0819 45.8338 40.0819 50.2114 38.888C51.4073 38.5644 52.4975 37.9332 53.3735 37.0572C54.2495 36.1812 54.8807 35.091 55.2043 33.8951C56.601 26.1056 57.0313 14.2602 55.1681 6.76018Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5703 28.7937L37.1868 20.3276L22.5703 11.8615V28.7937Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_3212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56.4141,
    height: 39.6661,
    fill: "white",
    transform: "translate(0 0.573364)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a8fc7ec79cde43484880fc7f72c2551f.svg";
export { ForwardRef as ReactComponent };